import { spawn } from 'redux-saga/effects'
import { fetchETFsSaga, fetchReportSaga } from './etfs';

export default function* rootSaga() {
  yield spawn(fetchETFsSaga);
  yield spawn(fetchReportSaga);
}
